import {Component} from 'react'
import Navbar from '../Navbar'
import ProjectsItem from '../ProjectsItem'
import './index.css'

const ProjectsList = [
  {
    id: 1,
    url: 'https://sumotodoapp.ccbp.tech/',
    image:
      'https://img.freepik.com/free-photo/time-organization-concept-close-up_23-2149046744.jpg?w=996&t=st=1706452898~exp=1706453498~hmac=b6c302ca909c4f45930b8ed351d6201961558293495f0ac65e0ae3e813421b11',
    technology: 'Javascript',
    name: 'Todo App',
  },
  {
    id: 2,
    url: 'https://smarmeto.ccbp.tech/',
    image:
      'https://img.freepik.com/free-vector/online-shopping-concept-landing-page_52683-22153.jpg?w=996&t=st=1706453043~exp=1706453643~hmac=69d7d52a90ce3e02ccc07a6ad0678e4b051121e2330284b7e4df6430da2ff9fe',
    technology: 'Javascript',
    name: 'Shopping App',
  },
  {
    id: 3,
    url: 'https://sumojobby.ccbp.tech/',
    image:
      'https://img.freepik.com/free-vector/man-search-hiring-job-online-from-laptop_1150-52728.jpg?w=1060&t=st=1706453154~exp=1706453754~hmac=a563ff442d45b7f1cac6c9ffa72e0dc83688676c9bfa7d4c35b75314b69b3a4d',
    technology: 'React Js',
    name: 'Jobby App',
  },
  {
    id: 4,
    url: 'https://restos.ccbp.tech/',
    image:
      'https://img.freepik.com/free-photo/photo-table-with-traditional-indian-food-celebrate-diwali_125540-3655.jpg?t=st=1706453557~exp=1706457157~hmac=4556f8c3b6c426d1d0d546b0949dbaf4a1eea29c7cbadbf8ca9142781fc3c88e&w=996',
    technology: 'React Js',
    name: 'Resto App',
  },
  {
    id: 5,
    url: 'https://sumonxttrends.ccbp.tech/',
    image:
      'https://img.freepik.com/premium-photo/group-people-standing-around-different-colored-shapes-generative-ai_899870-2665.jpg?w=996',
    technology: 'React Js',
    name: 'NxtTrendz App',
  },
  {
    id: 6,
    url: 'https://sumonxtwatch.ccbp.tech/',
    image:
      'https://img.freepik.com/free-photo/view-3d-tv_23-2151066950.jpg?t=st=1706453720~exp=1706457320~hmac=29f19afa4f2d459fa59e4409fbdc136d8a095967ff4fd83afda700f1479716fb&w=996',
    technology: 'React Js',
    name: 'NxtWatch App',
  },
  {
    id: 7,
    url: 'https://sumo1.ccbp.tech/',
    image:
      'https://img.freepik.com/premium-photo/technology-securities-concept-with-security-encryption-cybersecurity-network-data-protection_629685-968.jpg?w=996',
    technology: 'Javascript',
    name: 'Password Manager',
  },
  {
    id: 8,
    url: 'https://askmebuddy.ccbp.tech/',
    image:
      'https://img.freepik.com/premium-photo/book-with-globe-it_850197-1445.jpg?w=1060',
    technology: 'Javascript',
    name: 'Askmebuddy App',
  },
  {
    id: 9,
    url: 'https://trafficsignal.ccbp.tech/',
    technology: 'Javascript',
    name: 'Traffic Signal',
    image:
      'https://img.freepik.com/free-photo/dark-style-sky-nighttime_23-2151103571.jpg?t=st=1706453895~exp=1706457495~hmac=869b829bf795850cf44d546c27b2c70ed8cf408446e9b47795e0e7ef94dfd94b&w=996',
  },
  {
    id: 10,
    url: 'https://onoff22.ccbp.tech/',
    image:
      'https://img.freepik.com/free-photo/lamp-with-light-it-that-is-made-by-company-company_1340-25067.jpg?t=st=1706453947~exp=1706457547~hmac=c1fafed849c995cc8a5c539bb23ca1a5f93aa27d54cefe8c91cc4c1fe3ae3d43&w=996',
    technology: 'Javascript',
    name: 'Switch On and Off',
  },
]

console.log(ProjectsList)

class Project extends Component {
  render() {
    return (
      <div className="project-container">
        <Navbar />
        <hr className="line" />
        <ul className="projects-card">
          {ProjectsList.map(each => (
            <ProjectsItem key={each.id} data={each} />
          ))}
        </ul>
      </div>
    )
  }
}

export default Project
